import type { CoverageChecklist, DomainIssue, IndexPagination } from "@/types";
import CoverageChecklistCard from "./CoverageChecklistCard";
import OpenIssuesList from "./OpenIssuesList";

type Props = {
  coverage: CoverageChecklist;
  canAddPages: boolean;
  onAddPages: () => void;
  onWatchItem: (item: CoverageChecklist["items"][number]) => void;
  domainId: string;
  issues: DomainIssue[];
  staff?: boolean;
  evaluating?: boolean;
  expandedIssueId?: string | null;
  paging: { pagination: IndexPagination; buildPageHref: (page: number) => string };
  onWatchIssue: (issue: DomainIssue) => void;
};

export default function DomainFindingsPair({
  coverage,
  canAddPages,
  onAddPages,
  onWatchItem,
  domainId,
  issues,
  staff = false,
  evaluating = false,
  expandedIssueId = null,
  paging,
  onWatchIssue,
}: Props) {
  const issuesList = (
    <OpenIssuesList
      domainId={domainId}
      issues={issues}
      staff={staff}
      evaluating={evaluating}
      expandedIssueId={expandedIssueId}
      paging={paging}
      onWatchIssue={onWatchIssue}
    />
  );

  if (evaluating || coverage.items.length === 0) return issuesList;

  return (
    <div className="xl:mb-6 xl:grid xl:grid-cols-[minmax(0,2fr)_minmax(0,1fr)] xl:items-stretch xl:gap-6 [&_.dashboard-section]:xl:mb-0">
      <div className="min-w-0 xl:col-start-2 xl:row-start-1 xl:flex xl:h-full xl:flex-col">
        <CoverageChecklistCard
          coverage={coverage}
          canAddPages={canAddPages}
          onAddPages={onAddPages}
          onWatchItem={onWatchItem}
        />
      </div>
      <div className="min-w-0 xl:col-start-1 xl:row-start-1 xl:flex xl:h-full xl:flex-col">{issuesList}</div>
    </div>
  );
}
